module.exports = __webpack_public_path__ + "img/art-6.3921eadf.jpg";